import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const title = css`
  font-weight: 700;
  font-size: 18px;
  color: ${theme.colors.peoople['gris-oscuro']};
`;

export const scrollable = css`
  margin: 0 -0.75rem;

  @media screen and (width > ${theme.sizes.screens.lg}) {
    margin: initial;
  }
`;

export const cards = css`
  display: flex;
  gap: 1rem;
  flex-wrap: nowrap;
  padding: 0 1rem;

  @media screen and (width > ${theme.sizes.screens.lg}) {
    padding: initial;
  }
`;

export const card = css`
  width: var(--card-width);
  display: flex;
  flex: 0;
  flex-direction: column;
  gap: 0.5rem;
  --recomended-width: calc(100vw / 3);
  --card-width: clamp(150px, var(--recomended-width), 200px);

  @media screen and (width > ${theme.sizes.screens.lg}) {
    --recomended-width: calc(100vw / 6);
  }
`;

export const cover = css`
  aspect-ratio: 9 / 15;
  min-width: var(--card-width);
  border-radius: 1rem;
`;

export const square = css`
  aspect-ratio: 1;
`;

export const cardTitle = css`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
`;

export const cardCategory = css`
  color: ${theme.colors.peoople['gris-medio']};
  font-size: 16;
  font-weight: 600;
`;
